export default "__VITE_ASSET__kCUvCdeZ__"